var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-organization"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organization",
    clipPath: "url(#clip-organization)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(-43.586 -811.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(43.904 813.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M79.993,836.544H77.531v-2.459a3.286,3.286,0,0,0-3.28-3.282H64.408v-4.1h2.461a3.286,3.286,0,0,0,3.28-3.282v-6.561a3.284,3.284,0,0,0-3.28-3.28H60.308a3.284,3.284,0,0,0-3.282,3.28v6.561a3.286,3.286,0,0,0,3.282,3.282h2.459v4.1H52.926a3.286,3.286,0,0,0-3.282,3.282v2.459H47.184a3.285,3.285,0,0,0-3.28,3.281v6.563a3.285,3.285,0,0,0,3.28,3.28h6.561a3.284,3.284,0,0,0,3.28-3.28v-6.563a3.284,3.284,0,0,0-3.28-3.281H51.286v-2.459a1.642,1.642,0,0,1,1.64-1.642H74.251a1.643,1.643,0,0,1,1.64,1.642v2.459H73.43a3.285,3.285,0,0,0-3.28,3.281v6.563a3.285,3.285,0,0,0,3.28,3.28h6.563a3.285,3.285,0,0,0,3.28-3.28v-6.563A3.285,3.285,0,0,0,79.993,836.544Zm-26.247,1.64a1.641,1.641,0,0,1,1.64,1.64v6.563a1.641,1.641,0,0,1-1.64,1.64H47.184a1.641,1.641,0,0,1-1.64-1.64v-6.563a1.641,1.641,0,0,1,1.64-1.64Zm6.563-13.122a1.642,1.642,0,0,1-1.64-1.642v-6.561a1.641,1.641,0,0,1,1.64-1.64h6.561a1.641,1.641,0,0,1,1.64,1.64v6.561a1.642,1.642,0,0,1-1.64,1.642Zm21.325,21.325a1.643,1.643,0,0,1-1.64,1.64H73.43a1.643,1.643,0,0,1-1.64-1.64v-6.563a1.642,1.642,0,0,1,1.64-1.64h6.563a1.642,1.642,0,0,1,1.64,1.64v6.563Z",
    transform: "translate(-43.904 -813.579)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.aa76f092dd69190d2f24da613ca724d4.svg";
export { ForwardRef as ReactComponent };